module.exports = __webpack_public_path__ + "img/houguzhiyou.b6565e7d.png";